/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is percentage change?`)
};

const es_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el cambio porcentual?`)
};

const de_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist die prozentuale Veränderung?`)
};

const nl_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is percentageverandering?`)
};

const fr_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que la variation en pourcentage ?`)
};

const it_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è la variazione percentuale?`)
};

const pt_br2_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é variação percentual?`)
};

const pt_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a variação percentual?`)
};

const ja_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント変化とは？`)
};

const zh_pct_change_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是百分比变化？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_faq1_q", locale)
	if (locale === "en") return en_pct_change_faq1_q(inputs)
	if (locale === "es") return es_pct_change_faq1_q(inputs)
	if (locale === "de") return de_pct_change_faq1_q(inputs)
	if (locale === "nl") return nl_pct_change_faq1_q(inputs)
	if (locale === "fr") return fr_pct_change_faq1_q(inputs)
	if (locale === "it") return it_pct_change_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_faq1_q(inputs)
	if (locale === "pt") return pt_pct_change_faq1_q(inputs)
	if (locale === "ja") return ja_pct_change_faq1_q(inputs)
	return zh_pct_change_faq1_q(inputs)
};